import { biLogger } from './logger';
import { EditorType, Origin } from '../components/manage-installed-apps-page';
export var getOriginForBi = function (origin, editorType) {
    if (origin === Origin.BIZMGR) {
        return editorType === EditorType.ADI ? 'adi_dashboard' : 'dashboard';
    }
    return origin;
};
export var sendAddAppBi = function (origin, msid, editorType) {
    biLogger
        .manageAppsAddApp({
        market: getOriginForBi(origin, editorType),
        msid: msid,
        referral_info: 'manage_apps',
    })
        .catch(function (e) { return console.log(e); });
};
export var sendDeletePendingAppClickBi = function (app, origin, msid, editorType) {
    biLogger
        .manageAppsDeletePendingAppClick({
        appId: app.webSolutionBase.id,
        appInstanceId: app.instanceId,
        market: getOriginForBi(origin, editorType),
        msid: msid,
    })
        .catch(function (e) { return console.log(e); });
};
export var sendUpgradeSiteBi = function (app, origin, msid, editorType, sale_name) {
    biLogger
        .manageAppsUpgradeSite({
        appId: app.webSolutionBase.id,
        appInstanceId: app.instanceId,
        market: getOriginForBi(origin, editorType),
        msid: msid,
        sale_name: sale_name,
    })
        .catch(function (e) { return console.log(e); });
};
export var sendContextMenuActionBi = function (app, origin, msid, contextAction, editorType) {
    biLogger
        .manageAppsContextMenuAction({
        appId: app.webSolutionBase.id,
        appInstanceId: app.instanceId,
        contextAction: contextAction,
        market: getOriginForBi(origin, editorType),
        msid: msid,
    })
        .catch(function (e) { return console.log(e); });
};
export var sendOpenContextMenuBi = function (app, origin, msid, editorType) {
    biLogger
        .manageAppsOpenContextMenu({
        appId: app.webSolutionBase.id,
        appInstanceId: app.instanceId,
        market: getOriginForBi(origin, editorType),
        msid: msid,
    })
        .catch(function (e) { return console.log(e); });
};
export var sendAddPendingAppBi = function (app, origin, msid, editorType) {
    biLogger
        .__deprecated__91({
        app_id: app.webSolutionBase.id,
        market: getOriginForBi(origin, editorType),
        msid: msid,
        pending_source: 'manage_apps',
    })
        .catch(function (e) { return console.log(e); });
};
export var sendOpenManageAppsBi = function (origin, msid, editorType) {
    biLogger
        .appMarketOpenManageApps({
        msid: msid,
        market: getOriginForBi(origin, editorType),
    })
        .catch(function (e) { return console.log(e); });
};
export var getSolutionsBiData = function (solutions, origin, msid, section, editorType) {
    if (solutions) {
        return solutions.map(function (solution, index) {
            return {
                msid: msid,
                appId: solution.id,
                impressionType: 'box',
                index: index,
                market: getOriginForBi(origin, editorType),
                tagName: 'manage_apps',
                tagType: 'manage_apps',
                section: section,
            };
        });
    }
    return [];
};
export var sendCloseSupportModalBiEvent = function (app, origin, msId, isAppInstalled, clickSource, pageName, editorType) {
    biLogger
        .appMarketSupportMailModalClosedX({
        app_id: app.webSolutionBase.id,
        instance_id: app.instanceId,
        msid: msId,
        market: getOriginForBi(origin, editorType),
        is_app_installed: isAppInstalled,
        origin: clickSource,
        tag_type: pageName,
    })
        .catch(function (e) { return console.log(e); });
};
export var sendSupportModalOpenedBiEvent = function (app, origin, msId, isAppInstalled, clickSource, pageName, editorType) {
    biLogger
        .appMarketSupportMailModalOpened({
        app_id: app.webSolutionBase.id,
        instance_id: app.instanceId,
        msid: msId,
        market: getOriginForBi(origin, editorType),
        is_app_installed: isAppInstalled,
        origin: clickSource,
        tag_type: pageName,
    })
        .catch(function (e) { return console.log(e); });
};
export var sendDeleteModalOpenedBiEvent = function (appId, msId, origin, editorType) {
    biLogger
        .appMarketDeleteModalModalOpened({
        app_id: appId,
        market: getOriginForBi(origin, editorType),
        msid: msId,
        origin: 'context_menu',
        tag_type: 'manage_apps',
    })
        .catch(function (e) { return console.log(e); });
};
export var sendCanceledAppDeletionInDeleteModalBiEvent = function (appId, msId, origin, editorType) {
    biLogger
        .appMarketDeleteModalCancelAppDeleteX({
        app_id: appId,
        market: getOriginForBi(origin, editorType),
        msid: msId,
        origin: 'context_menu',
        tag_type: 'manage_apps',
    })
        .catch(function (e) { return console.log(e); });
};
export var sendAppDeletedFromDeleteModalBiEvent = function (appId, msId, origin, deleteReason, deleteDetails, reasonIndex, editorType) {
    biLogger
        .appMarketDeleteModalDeleteAppApproved({
        app_id: appId,
        delete_details: deleteDetails,
        delete_reason: deleteReason,
        reason_index: reasonIndex,
        market: getOriginForBi(origin, editorType),
        msid: msId,
        origin: 'context_menu',
        tag_type: 'manage_apps',
    })
        .catch(function (e) { return console.log(e); });
};
export var sendDeleteModalClickOnCustomerCareBiEvent = function (appId, msId, origin, editorType) {
    biLogger
        .appMarketDeleteModalClickOnCustomerCare({
        app_id: appId,
        market: getOriginForBi(origin, editorType),
        msid: msId,
        tag_type: 'manage_apps',
    })
        .catch(function (e) { return console.log(e); });
};
//# sourceMappingURL=biEvents.js.map